/**
 * @const PC_DOCUMENT_TYPE_RESET
 * @type {string}
 */
export const PNP_DOCUMENT_TYPE_RESET = 'PNP_DOCUMENT_TYPE_RESET';

/**
 * @const PNP_DOCUMENT_CATEGORY_RESET
 * @type {string}
 */
export const PNP_DOCUMENT_CATEGORY_RESET = 'PNP_DOCUMENT_CATEGORY_RESET';

/**
 * @const PNP_DOCUMENT_CATEGORY_DETAILS
 * @type {string}
 */
export const PNP_DOCUMENT_CATEGORY_DETAILS = 'PNP_DOCUMENT_CATEGORY_DETAILS';

/**
 * @const PNP_SETTINGS_APPROVAL_WORKFLOW_RESET
 * @type {string}
 */
export const PNP_SETTINGS_APPROVAL_WORKFLOW_RESET = 'PNP_SETTINGS_APPROVAL_WORKFLOW_RESET';

/**
 * @const PNP_SETTINGS_APPROVAL_WORKFLOW_DETAILS
 * @type {string}
 */
export const PNP_SETTINGS_APPROVAL_WORKFLOW_DETAILS = 'PNP_SETTINGS_APPROVAL_WORKFLOW_DETAILS';

/**
 * @const PNP_DOCUMENT_TYPES
 * @type {string}
 */
export const PNP_DOCUMENT_TYPES = 'PNP_DOCUMENT_TYPES';

/**
 * @const PNP_DOCUMENT_CATEGORIES
 * @type {string}
 */
export const PNP_DOCUMENT_CATEGORIES = 'PNP_DOCUMENT_CATEGORIES';

/**
 * @const PNP_DOCUMENT_RISK_LEVELS
 * @type {string}
 */
export const PNP_DOCUMENT_RISK_LEVELS = 'PNP_DOCUMENT_RISK_LEVELS';

/**
 * @const PNP_DOCUMENT_APPLICATION_TYPES
 * @type {string}
 */
export const PNP_DOCUMENT_APPLICATION_TYPES = 'PNP_DOCUMENT_APPLICATION_TYPES';

/**
 * @const PNP_AUDIT_TYPES
 * @type {string}
 */
export const PNP_AUDIT_TYPES = 'PNP_AUDIT_TYPES';

/**
 * @const PNP_CONTAINER_TYPES
 * @type {string}
 */
export const PNP_CONTAINER_TYPES = 'PNP_CONTAINER_TYPES';

/**
 * @const PNP_ADD_REVIEWERS_CONTACTS
 * @type {string}
 */
export const PNP_ADD_REVIEWERS_CONTACTS = 'PNP_ADD_REVIEWERS_CONTACTS';

/**
 * @const PNP_REMOVE_REVIEWERS_CONTACTS
 * @type {string}
 */
export const PNP_REMOVE_REVIEWERS_CONTACTS = 'PNP_REMOVE_REVIEWERS_CONTACTS';

/**
 * @const PNP_ADD_APPROVERS_CONTACTS
 * @type {string}
 */
export const PNP_ADD_APPROVERS_CONTACTS = 'PNP_ADD_APPROVERS_CONTACTS';

/**
 * @const PNP_REMOVE_APPROVERS_CONTACTS
 * @type {string}
 */
export const PNP_REMOVE_APPROVERS_CONTACTS = 'PNP_REMOVE_APPROVERS_CONTACTS';

/**
 * @const PNP_DEFAULT_CATEGORIES
 * @type {string}
 */
export const PNP_DEFAULT_CATEGORIES = 'PNP_DEFAULT_CATEGORIES';